<!-- components/GuestBillingInfo.vue -->
<template>
  <BModal
    id="modal-tall"
    :model-value="modalDetail"
    scrollable
    centered
    title="Reservation Detail"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Reservation Merge Invoice</h5>
        <!-- <div class="d-flex align-items-center">
            <span class="mr-2">17/02/2025 16:00:00</span>
            <div class="bg-success rounded-circle" style="width: 10px; height: 10px;"></div>
            <span>online: Ruth</span>
          </div> -->
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <div class="guest-info text-start" id="printArea">
      <!--  Kop & logo (print)  -->
      <div class="print-only" style="text-align: center; margin: 0; padding: 0">
        <table
          class="w-full border-collapse"
          style="width: 100%; border-collapse: collapse"
        >
          <tbody style="padding: 0; margin: 0">
            <tr class="border-b border-transparent">
              <td class="text-center" style="text-align: center">
                <img
                  src="../../../public/img/hotel-deliriver.png"
                  alt="Deli River Hotel Logo"
                  style="width: 50px; height: auto"
                />
              </td>
            </tr>
            <tr
              class="border-b border-transparent"
              style="padding: 0px; margin: 0px"
            >
              <td class="text-center">
                <h3 class="text-center">Deli River Hotel</h3>
                <p class="text-center">
                  Jl. Raya Namorambe No. 129, Medan, Indonesia
                </p>
                <p class="text-center">www.hotel-deliriver.com</p>
                <p class="text-center">contact@hotel-deliriver.com</p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <hr />
        <br />
        <p class="text-center"><strong>Reservation Invoice</strong></p>
      </div>

      <!-- <h4 class="print-only text-center">Reservation Invoice</h4> -->

      <div>
        <p class="text-secondary fw-semibold">Guest Information</p>
        <table class="w-full text-left border-collapse">
          <tbody>
            <tr class="border-b border-transparent">
              <td class="text-left">Date</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ dateFormatter(data?.created_at) }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Res. Number</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.number ?? "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Booking Source</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.source?.type ?? "-" }} -
                {{ data?.source?.name ?? "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Guest</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.guest?.fullname ?? "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left"></td>
              <td class="text-left"></td>
              <td class="text-left fw-semibold"></td>
            </tr>
            <!-- <tr class="screen-only border-b border-transparent">
                <td class="text-left">Contact</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  0{{ data?.reservation?.guest?.phone ?? "-" }}
                </td>
              </tr> -->
          </tbody>
        </table>
      </div>
      <br />
      <div>
        <!-- Reservation Items Table -->
        <!-- <p class="text-secondary fw-semibold mt-4 print-only">
                    Reservation List
                </p> -->

        <table
          class="w-full border-collapse print-only"
          style="width: 100%; border-collapse: collapse; font-size: 14px"
        >
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 6px">Booking ID</th>
              <th style="border: 1px solid #000; padding: 6px">Room</th>
              <th style="border: 1px solid #000; padding: 6px">Nights</th>
              <th style="border: 1px solid #000; padding: 6px">Price rate</th>
              <th style="border: 1px solid #000; padding: 6px">Disc</th>
              <th style="border: 1px solid #000; padding: 6px">Amount</th>
            </tr>
          </thead>

          <tbody>
            <!-- Loop Reservation Items -->
            <tr v-for="(item, i) in data?.reservation_items" :key="i">
              <td style="border: 1px solid #000; padding: 6px">
                {{ item.reservation?.number ?? "-" }}
              </td>

              <td style="border: 1px solid #000; padding: 6px">
                {{ item.reservation?.room?.room_category?.name ?? "-" }}
                <br />
                <small>
                  ({{ dateFormatter(item.reservation?.start) }}
                  to
                  {{ dateFormatter(item.reservation?.end) }})
                </small>
              </td>

              <td style="border: 1px solid #000; padding: 6px">
                {{ item.reservation?.days ?? 0 }}
              </td>

              <td style="border: 1px solid #000; padding: 6px">
                {{ formatIDR(item.reservation?.room_price ?? 0) }}
              </td>

              <td style="border: 1px solid #000; padding: 6px">
                {{ item.reservation?.discount ?? "0%" }}
              </td>

              <td style="border: 1px solid #000; padding: 6px">
                {{ formatIDR(item.reservation?.grand_total ?? 0) }}
              </td>
            </tr>

            <!-- Extra Charges (if any) -->

            <tr v-if="extraCharges.some((item) => item.quantity > 0)">
              <td colspan="6" style="border: 1px solid #000; padding: 6px">
                <p>Included Extra Charges:</p>
                <p v-for="(item, i) in extraCharges" :key="'e' + i">
                  <template v-if="item.quantity > 0">
                    {{ item.name }} ({{ item.quantity }}x)
                    {{ formatIDR(item.price) }}
                  </template>
                </p>
              </td>
            </tr>

            <!-- TOTAL -->
            <tr style="font-weight: bold">
              <td
                colspan="5"
                style="border: 1px solid #000; padding: 6px; text-align: right"
              >
                Grand Total :
              </td>
              <td style="border: 1px solid #000; padding: 6px">
                {{ formatIDR(totalAmount) }}
              </td>
            </tr>

            <!-- Down Payment -->
            <tr style="font-weight: bold">
              <td
                colspan="5"
                style="border: 1px solid #000; padding: 6px; text-align: right"
              >
                Down Payment :
              </td>
              <td style="border: 1px solid #000; padding: 6px">
                {{ formatIDR(totalPaid) }}
              </td>
            </tr>

            <!-- Rest Payment -->
            <tr style="font-weight: bold">
              <td
                colspan="5"
                style="border: 1px solid #000; padding: 6px; text-align: right"
              >
                Rest Payment :
              </td>
              <td style="border: 1px solid #000; padding: 6px; color: red">
                {{ formatIDR(restPayment) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="print-only mt-4">
        <br />
        <br />
        <p class="text-secondary fw-italic">
          Please kindly transfer the total amount to our account below :
        </p>
        <table class="w-full text-left border-collapse">
          <tbody>
            <tr class="border-b border-transparent">
              <td class="text-left">Payment Method</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.payment_method?.type ?? "-" }}-{{
                  data?.payment_method?.name ?? "-"
                }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Account Number</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.payment_method?.number ?? "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Account Name</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.payment_method?.owned_by ?? "-" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <!--  Tanda tangan (print) -->
      <div class="print-only" style="text-align: center; margin: 0; padding: 0">
        <div>
          <p><strong>Reservation Dept.</strong></p>
          <br /><br />
          <p>{{ adminData?.fullname ?? "Reservation Dept." }}</p>
          <p>______________________</p>
        </div>
        <!-- <div>
            <p>&nbsp;</p>
            <p><strong>Tamu</strong></p><br><br>
            <p>______________________</p>
          </div> -->
      </div>
    </div>

    <template #footer>
      <div class="d-flex justify-content-end">
        <!-- Tombol cetak invoice biasa -->
        <BButton variant="warning" class="mr-2" @click="handlePrint"
          >Print</BButton
        >
        <BButton
          v-if="
            (extraCharges && extraCharges.length > 0) ||
            data?.extracharge?.filter((e) => Number(e.quantity) > 0)?.length
          "
          variant="info"
          class="mr-2"
          @click="handlePrintExtraCharge"
        >
          Print Extra Charge
        </BButton>

        <!-- <BButton variant="primary" @click="submitReservation"  class="mr-2">Save</BButton> -->
        <BButton variant="danger" @click="updateModal(false)">Close</BButton>
      </div>
    </template>
  </BModal>
</template>

<script>
//   defineProps({
//     data: Object,
//   })
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";
import { countDays } from "@/utils/dateCalculation";
import { getFormattedDate } from "@/composable/getDateTimeFormatter";

import {
  BModal,
  BButton,
  // BRow,
  // BCol,
  // BForm,
  // BTabs,
  // BTab,
  // BFormInput,
  // BFormSelect,
  // BFormSelectOption,
  // BInputGroup,
  // BListGroup,
  // BListGroupItem,
  // BFormTextarea,
  // BFormRadioGroup
} from "bootstrap-vue-next";

export default {
  name: "CheckOutDetail",
  components: {
    BModal,
    BButton,
    // BRow,
    // BCol,
    // BForm,
    // BTabs,
    // BTab,
    // BFormInput,
    // BFormSelect,
    // BFormSelectOption,
    // BInputGroup,
    // BButton,
    // BListGroup,
    // BListGroupItem,
    // BFormTextarea,
    // BFormRadioGroup
  },

  props: {
    modal: Boolean,
    data: Object,
    title: { type: String, default: "Detail" },
    //modelValue:  { type: Boolean, default: false },
    adminData: {
      type: Object,
      default: null,
    },
  },

  emits: ["update:modal", "update:modelValue"],

  setup(props, { emit }) {
    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    return {
      formatIDR,
      dateFormatter,
      countDays,
      getFormattedDate,
      updateModal,
    };
  },

  computed: {
    extraCharges() {
      const list = [];
      this.data?.reservation_items?.forEach((item) => {
        item.reservation?.extracharge?.forEach((ex) => {
          list.push({
            name: ex.extra_charge?.name,
            description: ex.extra_charge?.description ?? "",
            quantity: ex.quantity,
            price: ex.extra_charge?.price ?? 0,
            total: (ex.extra_charge?.price ?? 0) * ex.quantity,
          });
        });
      });
      return list;
    },

    totalAmount() {
      let sum = 0;

      this.data?.reservation_items?.forEach((i) => {
        sum += Number(i.reservation?.grand_total ?? 0);
      });

      return sum;
    },

    totalPaid() {
      let paid = 0;

      this.data?.reservation_items?.forEach((i) => {
        paid += Number(i.reservation?.total_paid ?? 0);
      });

      return paid;
    },

    hasExtraCharge() {
      if (this.extraCharges && this.extraCharges.length > 0) return true;
      if (
        this.data?.extracharge &&
        this.data.extracharge.filter((e) => Number(e.quantity) > 0).length > 0
      )
        return true;
      return false;
    },

    restPayment() {
      return this.totalAmount - this.totalPaid;
    },
  },

  methods: {
    formatCurrencyNumber(val) {
      const num = Number(val) || 0;
      return new Intl.NumberFormat("id-ID").format(num);
    },

    formatDateReceipt(dateInput) {
      if (!dateInput) return "-";
      const d = new Date(dateInput);
      if (isNaN(d.getTime())) return String(dateInput);
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const day = String(d.getDate()).padStart(2, "0");
      const month = months[d.getMonth()];
      const year = String(d.getFullYear()).slice(-2);
      return `${day}-${month}-${year}`;
    },

    formatDateTimeReceipt(dateInput) {
      const d = dateInput ? new Date(dateInput) : new Date();
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const day = String(d.getDate()).padStart(2, "0");
      const month = months[d.getMonth()];
      const year = String(d.getFullYear()).slice(-2);
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    },

    handlePrintExtraCharge() {
      this.$nextTick(() => {
        let validCharges = [];

        if (this.extraCharges && this.extraCharges.length > 0) {
          validCharges = this.extraCharges;
        } else if (this.data?.extracharge) {
          validCharges = this.data.extracharge
            .filter((e) => Number(e.quantity) > 0)
            .map((e) => ({
              name: e.extra_charge?.name || "Extra Charge",
              quantity: Number(e.quantity) || 1,
              price: Number(e.price ?? e.extra_charge?.price ?? 0),
            }));
        }

        if (!validCharges.length) {
          alert("Tidak ada data Extra Charge untuk dicetak.");
          return;
        }

        const guestName =
          this.data?.guest?.fullname ||
          this.data?.guest_name ||
          this.data?.guest?.name ||
          "-";

        const reservationNumber = this.data?.number || "-";
        const roomNumber =
          this.data?.room?.code ||
          this.data?.reservation_items?.[0]?.reservation?.room?.code ||
          "-";
        const roomType =
          this.data?.room?.room_category?.name ||
          this.data?.reservation_items?.[0]?.reservation?.room?.room_category
            ?.name ||
          "-";
        const checkInDate = this.formatDateReceipt(
          this.data?.start || this.data?.check_in_date,
        );
        const checkOutDate = this.formatDateReceipt(
          this.data?.end || this.data?.check_out_date,
        );
        const currentDate = this.formatDateTimeReceipt(new Date());

        const cashierName =
          this.adminData?.fullname ||
          this.adminData?.name ||
          this.adminData?.username ||
          "Cashier";

        let grandTotal = 0;
        let itemsHtml = "";

        validCharges.forEach((item, index) => {
          const itemName = item.name || "Extra Charge";
          const qty = Number(item.quantity) || 1;
          const price = Number(item.price || 0);
          const subtotal = qty * price;

          grandTotal += subtotal;

          itemsHtml += `
                        <tr>
                            <td style="text-align: center; border: 1px solid #000; padding: 8px;">${
                              index + 1
                            }</td>
                            <td style="border: 1px solid #000; padding: 8px;">${itemName}</td>
                            <td style="text-align: center; border: 1px solid #000; padding: 8px;">${qty}</td>
                            <td style="text-align: right; border: 1px solid #000; padding: 8px;">Rp ${this.formatCurrencyNumber(
                              price,
                            )}</td>
                            <td style="text-align: right; border: 1px solid #000; padding: 8px;">Rp ${this.formatCurrencyNumber(
                              subtotal,
                            )}</td>
                        </tr>
                    `;
        });

        const filename = `BILL-EXTRACHARGE-${reservationNumber}`;

        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        iframe.setAttribute(
          "sandbox",
          "allow-modals allow-same-origin allow-scripts",
        );
        document.body.appendChild(iframe);

        const doc = iframe.contentDocument || iframe.contentWindow.document;

        doc.open();
        doc.write(`
                    <!DOCTYPE html>
                    <html>
                        <head>
                            <title>${filename}</title>
                            <meta name="viewport" content="width=device-width,initial-scale=1.0">
                            <style>
                                @page {
                                    size: A4 portrait;
                                    margin: 8mm 15mm 0 15mm;
                                }
                                * {
                                    box-sizing: border-box;
                                }
                                body {
                                    font-family: Arial, sans-serif;
                                    font-size: 11px;
                                    color: #000;
                                    background: #fff;
                                    margin: 0;
                                    padding: 0;
                                    line-height: 1.3;
                                }
                                .text-center { text-align: center; }
                                .text-right { text-align: right; }
                                .text-left { text-align: left; }
                                .fw-bold { font-weight: bold; }

                                .header-table {
                                    width: 100%;
                                    border-collapse: collapse;
                                    margin-bottom: 4px;
                                }
                                .header-table td {
                                    vertical-align: middle;
                                    border: none;
                                    padding: 0;
                                }
                                .hotel-logo {
                                    width: 50px;
                                    height: auto;
                                }
                                .hotel-name {
                                    font-size: 15px;
                                    font-weight: bold;
                                    letter-spacing: 0.5px;
                                    margin-bottom: 2px;
                                }
                                .hotel-sub {
                                    font-size: 10px;
                                    color: #333;
                                    margin: 0;
                                    line-height: 1.25;
                                }
                                .header-divider {
                                    border: none;
                                    border-top: 1.5px solid #000;
                                    margin: 6px 0 8px 0;
                                }
                                .doc-title {
                                    text-align: center;
                                    font-size: 13px;
                                    font-weight: bold;
                                    text-transform: uppercase;
                                    letter-spacing: 1px;
                                    margin-bottom: 8px;
                                }

                                .info-container {
                                    width: 100%;
                                    margin-bottom: 6px;
                                }
                                .info-table {
                                    width: 100%;
                                    border-collapse: collapse;
                                    font-size: 11px;
                                }
                                .info-table td {
                                    padding: 1.5px 0;
                                    vertical-align: top;
                                    border: none;
                                }
                                .info-label {
                                    width: 105px;
                                    color: #222;
                                }
                                .info-colon {
                                    width: 12px;
                                    text-align: center;
                                }

                                .items-table {
                                    width: 100%;
                                    border-collapse: collapse;
                                    font-size: 11px;
                                    margin-top: 4px;
                                    margin-bottom: 6px;
                                }
                                .items-table th {
                                    border: 1px solid #000;
                                    background-color: #f2f2f2;
                                    padding: 4px 6px;
                                    font-weight: bold;
                                    text-align: center;
                                }
                                .items-table td {
                                    border: 1px solid #000;
                                    padding: 4px 6px;
                                }

                                .signature-container {
                                    width: 100%;
                                    margin-top: 10px;
                                    page-break-inside: avoid;
                                }
                                .footer-note {
                                    text-align: center;
                                    font-size: 10px;
                                    font-style: italic;
                                    margin-top: 8px;
                                    color: #555;
                                }
                            </style>
                        </head>
                        <body>
                            <!-- Kop Surat Resmi -->
                            <table class="header-table">
                                <tr>
                                    <td style="width: 60px; text-align: center;">
                                        <img src="/img/hotel-deliriver.png" alt="Deli River Hotel Logo" class="hotel-logo" />
                                    </td>
                                    <td style="padding-left: 12px;">
                                        <div class="hotel-name">HOTEL DELI RIVER</div>
                                        <div class="hotel-sub">Restaurant Omlandia</div>
                                        <div class="hotel-sub">Jl. Raya Namorambe No. 129, Deli Tua, Medan, Sumatera Utara 20356</div>
                                        <div class="hotel-sub">Tel: (061) 7032964 / 7032967 | Web: www.hotel-deliriver.com | Email: contact@hotel-deliriver.com</div>
                                    </td>
                                </tr>
                            </table>

                            <div class="header-divider"></div>

                            <div class="doc-title">Extra Charge Bill</div>

                            <!-- Detail Reservasi / Tamu -->
                            <div class="info-container">
                                <table style="width: 100%; border-collapse: collapse;">
                                    <tr>
                                        <td style="width: 50%; vertical-align: top; border: none; padding-right: 15px;">
                                            <table class="info-table">
                                                <tr>
                                                    <td class="info-label">Guest Name</td>
                                                    <td class="info-colon">:</td>
                                                    <td class="fw-bold">${guestName}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Res. Number</td>
                                                    <td class="info-colon">:</td>
                                                    <td class="fw-bold">${reservationNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Room Number</td>
                                                    <td class="info-colon">:</td>
                                                    <td>${roomNumber} ${
          roomType !== "-" ? `(${roomType})` : ""
        }</td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td style="width: 50%; vertical-align: top; border: none; padding-left: 15px;">
                                            <table class="info-table">
                                                <tr>
                                                    <td class="info-label">Invoice Date</td>
                                                    <td class="info-colon">:</td>
                                                    <td>${currentDate}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Check In</td>
                                                    <td class="info-colon">:</td>
                                                    <td>${checkInDate}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Check Out</td>
                                                    <td class="info-colon">:</td>
                                                    <td>${checkOutDate}</td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <!-- Tabel Item Extra Charge -->
                            <table class="items-table">
                                <thead>
                                    <tr>
                                        <th style="width: 40px;">No</th>
                                        <th>Description / Item</th>
                                        <th style="width: 80px;">Qty</th>
                                        <th style="width: 140px;">Price</th>
                                        <th style="width: 150px;">Subtotal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${itemsHtml}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="4" style="text-align: right; font-weight: bold; padding: 4px 6px; border: 1px solid #000; background-color: #f9f9f9;">
                                            Grand Total
                                        </td>
                                        <td style="text-align: right; font-weight: bold; padding: 4px 6px; border: 1px solid #000; background-color: #f9f9f9;">
                                            Rp ${this.formatCurrencyNumber(
                                              grandTotal,
                                            )}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>

                            <!-- Tanda Tangan -->
                            <div class="signature-container">
                                <table style="width: 100%; border-collapse: collapse; margin-top: 6px;">
                                    <tr>
                                        <td style="width: 50%; text-align: center; border: none; vertical-align: top;">
                                            <div>Guest</div>
                                            <div style="height: 28px;"></div>
                                            <div>( ${guestName} )</div>
                                        </td>
                                        <td style="width: 50%; text-align: center; border: none; vertical-align: top;">
                                            <div>Front Office</div>
                                            <div style="height: 28px;"></div>
                                            <div>( ${cashierName} )</div>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <div class="footer-note">
                                Thank you for visiting Deli River Hotel & Restaurant Omlandia
                            </div>
                        </body>
                    </html>
                `);
        doc.close();

        iframe.onload = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          setTimeout(() => {
            if (document.body.contains(iframe)) {
              document.body.removeChild(iframe);
            }
          }, 1000);
        };
      });
    },
    handlePrint() {
      this.$nextTick(() => {
        const printContents = document.getElementById("printArea").innerHTML;
        //const printWindow = window.open("", "", "width=80,height=auto");

        // Ambil nomor booking dari data (gunakan fallback kalau undefined)
        const bookingNumber = this.data?.number || "unknown";

        const now = new Date();
        const pad = (num) => String(num).padStart(2, "0");
        const formattedDate = `${now.getFullYear()}-${pad(
          now.getMonth() + 1,
        )}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(
          now.getMinutes(),
        )}-${pad(now.getSeconds())}`;
        //   const filename = `invoice-deli-river-hotel-${formattedDate}`;
        const filename = `invoice-HDR-${bookingNumber}-${formattedDate}`;

        // Penambahan buat iframe tersembunyi
        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        iframe.setAttribute(
          "sandbox",
          "allow-modals allow-same-origin allow-scripts",
        );
        document.body.appendChild(iframe);

        const doc = iframe.contentDocument || iframe.contentWindow.document;

        // const htmlTemplate =`
        //   <!DOCTYPE html>
        //   <html>
        //     <head>
        //       <title>${filename}</title>
        //       <meta name="viewport" content="width=device-width,initial-scale=1.0">
        //       <style>
        //         @media print
        //         {

        //           @page {
        //             size: 80mm auto;
        //           }
        //           body {
        //             font-family: sans-serif;
        //             font-size: 8px;
        //             margin: 10px;
        //             padding: 0;
        //           }
        //           h2 {
        //             font-size: 10px;
        //             margin: 0;
        //           }
        //           h3 {
        //             margin: 0;
        //           }
        //           h4 {
        //             margin: 0;
        //           }
        //           p {
        //             margin: 3px 0px;
        //           }
        //           .billing-detail {
        //             margin-top: -5px;
        //           }
        //           hr {
        //             margin-top: -5px;
        //           }
        //           tbody {
        //             margin: 0px;
        //           }
        //         }
        //       </style>
        //     </head>
        //     <body>
        //       ${printContents}
        //     </body>
        //   </html>
        // `;

        // printWindow.document.write(htmlTemplate);
        // printWindow.document.close();
        // printWindow.focus();

        // setTimeout(() => {
        //   printWindow.print();
        //   printWindow.close();
        // }, 1000);

        doc.open();
        doc.write(`
            <!DOCTYPE html>
            <html>
              <head>
                <title>${filename}</title>
                <meta name="viewport" content="width=device-width,initial-scale=1.0">
                <style>
                  @media print
                  {

                    @page {
                      size: 80mm auto;
                    }
                    body {
                      font-family: sans-serif;
                      font-size: 14px;
                      margin: 10px;
                      padding: 0;
                    }
                    h2 {
                      font-size: 10px;
                      margin: 0;
                    }
                    h3 {
                      margin: 0;
                    }
                    h4 {
                      margin: 0;
                    }
                    p {
                      margin: 3px 0px;
                    }
                    .billing-detail {
                      margin-top: -5px;
                    }
                    hr {
                      margin-top: -5px;
                    }
                    tbody {
                      margin: 0px;
                    }
                  }
                </style>
              </head>
              <body>
                ${printContents}
              </body>
            </html>
          `);
        doc.close();

        // Tunggu iframe selesai load sebelum print
        iframe.onload = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();

          // Bersihkan iframe setelah print
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 1000);
        };
      });
    },
  },
};
</script>

<style scoped>
/* style untuk print */
@media print {
  body * {
    visibility: hidden;
  }

  #printArea,
  #printArea * {
    visibility: visible;
  }

  #printArea {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  #printArea .situs {
    padding: 30px;
  }

  button {
    display: none !important;
  }

  .navbar,
  .footer,
  .btn {
    display: none;
  }

  .print-only {
    display: block !important;
  }

  .screen-only {
    display: none !important;
  }
}

/* Elemen hanya layar vs hanya print */
.print-only {
  display: none;
}

.screen-only {
  display: block;
}

.situs {
  padding: 20px;
  margin: 20px;
  color: red;
}
</style>
